// Layout
const dashboardLayout = () => import('@/layouts/CompanyLayout/DashboardLayout/dashboardLayout.vue')

const setting = () => import('./views/index')

// start Routes
export default [
  {
    path: '/company/settings',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'companySettings',
      meta: {
        name: 'companySettings',
        parentName: 'marketplace',
        userType: '',
        permission: '',
        role: 'transportation.company_owner'
      },
      component: setting
    }
    ]
  }
]
